import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { FeeResponse } from 'src/app/models/fee-response.model'

@Injectable({
  providedIn: 'root',
})
export class FeeService {
  public static readonly feeEndpoint = '/fee'

  constructor(private readonly http: HttpClient) {}

  getFee(fundId: string): Observable<FeeResponse> {
    return this.http.get<FeeResponse>(
      `vmf/api/${fundId}`.concat(FeeService.feeEndpoint),
    )
  }
}
